type ApplicationSuccessIconProps = {
  width?: number;
  height?: number;
};
/**
 * This icon has a different viewbox and stroke pattern than the one used in the generic Icon component.
 */
export const ApplicationSuccessIcon = (props: ApplicationSuccessIconProps) => {
  const { width = 25, height = 24 } = props;
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
    >
      <rect x='0.5' width='24' height='24' rx='12' fill='#08875D' />
      <path
        d='M8 12L11 15L17 9'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
